import { useFeatureFlagEnabled } from "@posthog/react";
import { useState } from "react";
import {
  devOverridesEnabled,
  useDevOverridesStore,
  type NewMentorUiOverride,
} from "@/lib/hooks/admin/use-dev-overrides";

export function resolveNewMentorUI(params: {
  flagEnabled: boolean;
  override: NewMentorUiOverride;
  overridesEnabled: boolean;
}): boolean {
  const { flagEnabled, override, overridesEnabled } = params;

  if (overridesEnabled) {
    switch (override) {
      case "new":
        return true;
      case "old":
        return false;
      case "default":
        break;
      default: {
        const _exhaustive: never = override;
        return _exhaustive;
      }
    }
  }

  return flagEnabled;
}

export function useNewMentorUI() {
  const [localDevOverride] = useState(
    () => localStorage.getItem("new-mentor-ui") === "true",
  );
  const flagEnabled =
    useFeatureFlagEnabled("new-mentor-ui") || localDevOverride;
  const override = useDevOverridesStore((s) => s.newMentorUiOverride);

  return resolveNewMentorUI({
    flagEnabled,
    override,
    overridesEnabled: devOverridesEnabled,
  });
}
